import React from "react";

import {
	addBigRoadDisplay,
	addRoadmapType,
	checkLastIdx,
	IXocDiaHistoryItem,
	prepareV3Render,
	renderV3,
	resetAnalysisPointer,
	resetDisplayPointer
} from "@/modules/games/BaccaratRoadmaps";

import { IV2RoadmapClass } from "@/types/V2RoadmapTypes";

export default class M40 extends IV2RoadmapClass {
	render() {
		// console.log("RL m40 render()", this.props);

		prepareV3Render(this);

		const history = this.props.history as IXocDiaHistoryItem[];
		if (!history) return null;

		//Obligatory counters
		this.currentRow = 0;
		this.currentCol = -1;
		this.currentType = "";

		if (this.props.type === "bead-road") {
			this.currentRow = -1;
			this.currentCol = 0;

			//Formula: history length divided by displayed rows
			if (Math.ceil(history.length / 6) >= this.totalColumns)
				this.firstDisplayedCol = Math.ceil(history.length / 6) - this.totalColumns;

			// console.log("RL m40 history", history);

			history.forEach((item, idx) => {
				if (this.currentRow >= 5) {
					this.currentRow = 0;
					this.currentCol += 1;
				} else
					this.currentRow += 1;

				const redCount = (item.angka.match(/Red/g) || []).length;
				const isOdd = redCount % 2 > 0;
				const oddLabel = isOdd ? "O" : "E";

				const baseStyle = "sl-roadmap-circle sl-roadmap-"
					+ (isOdd ? "blue" : "red")

				const alternatingStyle = checkLastIdx(history, idx)
					? this.alternatingStyle
					: "";

				const ele = (
					<div className={baseStyle + " " + alternatingStyle}>
						<div className={"sl-baccarat-bead-value " + alternatingStyle}>
							{oddLabel}
						</div>
					</div>
				);

				this.roadmapDisplay[this.currentRow][this.currentCol] = ele;
			});
		} else if (this.props.type === "big-road") {
			resetDisplayPointer(this);
			resetAnalysisPointer(this);

			this.simpleBigRoad
				.forEach((item, idx) => {
					const isOdd = item === "O";
					const baseStyle = "sl-roadmap-circle-hollow sl-roadmap-" + (
						isOdd ? "blue" : "red"
					);

					const alternatingStyle = checkLastIdx(this.simpleBigRoad, idx)
						? this.alternatingStyle
						: "";

					const element = (
						<div
							key={"sBR" + idx}
							className={baseStyle + " " + alternatingStyle}
						/>
					);

					addBigRoadDisplay(this, this.roadmapDisplay, element, item);

					// Use straight columns to set this.roadmapTypes columns, not dragon tail
					addRoadmapType(this, this.roadmapTypes, item);
				});

			resetDisplayPointer(this);
		}

		return renderV3(this);
	}
}